import { useMemo } from 'react';

export default function useFormType(data:any = null) {
  const type: 'add' | 'edit' = useMemo(
    () => ((!data || data.toString() === 'add') ? 'add' : 'edit'),
    [data],
  );
  return type;
}
